import {
  ADD_PROMPT_SECTION_DATA,
  DELETE_PROMPT_SECTION_DATA,
  FETCH_AI_THEME_REQUEST,
  FETCHING_AI_THEME_FAILED,
  FETCHING_AI_THEME_SUCCEEDED,
  PROMPT_EDITOR_SECTION_FAILED,
  PROMPT_EDITOR_SECTION_REQUEST,
  PROMPT_EDITOR_SECTION_SUCCEEDED,
  RESET_PROMPT_CREATION_FLOW,
  UPDATE_PROMPT_CREATION_DATA,
  UPDATE_PROMPT_SECTION_DATA,
  UPDATE_PROMPT_SECTION_ORDER_DATA,
} from "constants/actionTypes";

import shortid from 'shortid';

const initialState = {
  loading: false,
  prompt: null,
  contentType: null,
  data: null,
  aiTheme: null,
  templates: {
    loading: false,
    items: [],
    error: null,
  },
  invalidated: false,
  error: null,
};

const addIdsToSections = (sections) => {
  if (!sections || !Array.isArray(sections)) return sections;
  
  return sections.map(section => ({
    ...section,
    id: section.id || shortid.generate()
  }));
};

export function promptEditorReducer(state = initialState, action) {
  switch (action.type) {
    case PROMPT_EDITOR_SECTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PROMPT_EDITOR_SECTION_SUCCEEDED:
      const { response } = action.payload;

      let parsedData;
      try {
        parsedData =
          typeof response.answer === "string"
            ? JSON.parse(response.answer)
            : response.answer;
      } catch (e) {
        console.error("Failed to parse answer:", e);
        parsedData = response.answer;
      }
    
      const pageStructure = parsedData?.page_structure || parsedData;
      
      // Add IDs to sections if they exist
      if (pageStructure?.sections) {
        pageStructure.sections = addIdsToSections(pageStructure.sections);
      }
    
      const newState = {
        ...state,
        data: {
          storyboardId: response.storyboardId,
          pageId: response.pageId,
          prompt: response.prompt,
          session: response.session,
          pageStructure: pageStructure,
          storyboardName: response.storyboardName,
          pageName: response.pageName
        },
        loading: false,
        error: null,
      };
    
      return newState;

    case PROMPT_EDITOR_SECTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case FETCH_AI_THEME_REQUEST:
      return {
        ...state,
          templates: {
            ...state.templates,
            loading: true,
            error: null,
          },
      };

    case FETCHING_AI_THEME_SUCCEEDED:
      return {
        ...state,
          templates: {
            ...state.templates,
            loading: false,
            items: action.payload,
            error: null,
          }
      };

    case FETCHING_AI_THEME_FAILED:
      return {
        ...state,
          templates: {
            ...state.templates,
            loading: false,
            error: action.payload,
          },
      };

    case ADD_PROMPT_SECTION_DATA: {
      const { id, data } = action.payload;

      if (!state.data?.pageStructure?.sections) {
        return state;
      }

      const sections = [...state.data?.pageStructure.sections] || [];
      const index = sections.findIndex((section) => section.id === id);
      sections.splice(index + 1, 0, data);

      return {
        ...state,
        data: {
          ...state.data,
          pageStructure: {
            ...state.data.pageStructure,
            sections,
          },
        },
      };
    }

    case DELETE_PROMPT_SECTION_DATA: {
      const { id } = action.payload;

      if (!state.data?.pageStructure?.sections) {
        return state;
      }

      const sections = [...state.data?.pageStructure.sections] || [];
      const index = sections.findIndex((section) => section.id === id);
      sections.splice(index, 1);

      return {
        ...state,
        data: {
          ...state.data,
          pageStructure: {
            ...state.data.pageStructure,
            sections,
          },
        },
      };
    }

    case UPDATE_PROMPT_SECTION_DATA: {
      const { id, key, value } = action.payload;

      if (!state.data?.pageStructure?.sections) {
        return state;
      }

      const sections = state.data.pageStructure.sections.map((section) =>
        section.id === id ? { ...section, [key]: value } : section
      );

      return {
        ...state,
        data: {
          ...state.data,
          pageStructure: {
            ...state.data.pageStructure,
            sections,
          },
        },
      };
    }

    case UPDATE_PROMPT_SECTION_ORDER_DATA:
      return {
        ...state,
        data:{
          ...state.data,
          pageStructure: {
            sections: action.payload.pageStructure,
          },
        }
    };

    case UPDATE_PROMPT_CREATION_DATA:
      const { key, value } = action.payload;

      return {
        ...state,
        [key]: value,
      };

    case RESET_PROMPT_CREATION_FLOW:
      return {
          loading: false,
          prompt: null,
          contentType: null,
          data: null,
          vibe: null,
          template: [],
          error: null,
      };

    default:
      return state;
  }
}

// case PROMPT_EDITOR_SECTION_REQUEST:
//   return {
//     ...state,
//     isRequesting: true,
//     isStreaming: true,
//     streamData: [],
//     isComplete: false,
//     error: null,
//   };

// case PROMPT_EDITOR_SECTION_MESSAGE:
//   return {
//     ...state,
//     streamData: [...state.streamData, action.payload.message],
//   };

// case PROMPT_EDITOR_SECTION_SUCCEEDED:
//   return {
//     ...state,
//     isStreaming: false,
//     isComplete: true,
//   };

// case PROMPT_EDITOR_SECTION_FAILED:
//   return {
//     ...state,
//     isRequesting: false,
//     isStreaming: false,
//     error: action.payload.error,
//   };
